import { render, staticRenderFns } from "./EstablishmentsNew.vue?vue&type=template&id=03d351fa&"
import script from "./EstablishmentsNew.vue?vue&type=script&lang=js&"
export * from "./EstablishmentsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports